import React from 'react'
import DriveEtaOutlined from '@material-ui/icons/DriveEtaOutlined'

export default function DriveEtaOutlinedIcon(props) {
    const { ...other } = props

    return (
        <DriveEtaOutlined {...other} />
    )
}